// extracted by mini-css-extract-plugin
export default {"wrapper":"Eo-z","viewport":"Fo-z","container":"Go-z","slide":"Ho-z"};